import { render, staticRenderFns } from "./PolicyType.vue?vue&type=template&id=08837204&scoped=true"
import script from "./PolicyType.vue?vue&type=script&lang=js"
export * from "./PolicyType.vue?vue&type=script&lang=js"
import style0 from "./PolicyType.vue?vue&type=style&index=0&id=08837204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08837204",
  null
  
)

export default component.exports